import { ipfsGateways } from "../config";

// IPFS gateway configuration
export const IPFS_GATEWAYS = ipfsGateways
// Gateway rate limiting configuration
export const GATEWAY_RATE_LIMIT = 10; // Requests per window
export const RATE_LIMIT_WINDOW = 60 * 1000; // 1 minute
export const MAX_BACKOFF_DELAY = 30 * 1000; // 30 seconds max backoff

// Metadata caching configuration
export const METADATA_CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
export const PATTERN_CACHE_DURATION = 30 * 60 * 1000; // 30 minutes

// Batch processing configuration
export const METADATA_BATCH_SIZE = 5; // Conservative batch size for metadata
export const TOKEN_BATCH_SIZE = 20; // Batch size for token operations
export const PRELOAD_THRESHOLD = 0.5; // Start preloading when 50% through current page